// libs
import React, {useEffect, useState} from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
// components
import Navigation from "../../components/navbar";
import FormModal from './form-modal';
import "../../assets/css/style.css";
import BreadcrumbNav from "../../components/breadcrumb-nav";
import Loading from '../../components/loading';
import Table from './table';
import PrintErrorMsg from '../../components/print-error-msg';
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from '../../config';
import utils from '../../utils';
import { useSelectedAccount } from '../../context/account-context';
import { navigateListPageUrl } from '../../utils/list-page-url';
import { parseApiRecords } from '../../utils/parse-api-records';

function List({token, orgInfo}) {
	let query = utils.useQuery();
	const { selectedAccountId } = useSelectedAccount();
	const [ShowFormModalBox, setShowFormModalBox] = useState(false);
	const [FormRowId, setFormRowId] = useState(0);
	const [ListData, setListData] = useState([]);
	const [TotalListCount, setTotalListCount] = useState(0);
	const [IsLoading, setIsLoading] = useState(true);
	const [IsError, setIsError] = useState(null);
	const [SearchQInputVal, setSearchQInputVal] = useState(null);

	let urlSearchQ = query.get("searchQ");

	const handleChangeSearchQuery = (event) => {
		setSearchQInputVal(event.target.value);
	}

	const submitSearchQuery = () => {
		navigateListPageUrl(selectedAccountId, { set: { searchQ: SearchQInputVal } });
	}

	const loadApiData = async () => {
		setIsLoading(true);
		let apiCall = await ajaxCall.getCall(`${config.api.generic}/color`, {
			fSearchQ: urlSearchQ
		}, token, {"Domain": "vyayata"});
		if (apiCall && apiCall.status) {
			const records = parseApiRecords(apiCall);
			setListData(records);
			setTotalListCount(apiCall.context.message.data?.totalCount ?? records.length);
			setIsLoading(false);
			setIsError(null);
		} else {
			setListData([]);
			setTotalListCount(0);
			setIsLoading(false);
			setIsError(apiCall?.context?.message || 'Something went wrong while loading colors');
		}
    }

	const LoadTable = () => {
		if (IsLoading) {
			return <Loading />
		} else if (IsError) {
			return <PrintErrorMsg msg={IsError} />
		} else {
			return <Table
				loadapidata={loadApiData}
				list={ListData}
				orgInfo={orgInfo}
				token={token}
				onOpenFormModal={(id) => { setFormRowId(id); setShowFormModalBox(true); }}
			/>
		}
	}

	useEffect(() => {
        loadApiData();
    }, [urlSearchQ]);

	return (
		<>
			<Navigation orgInfo={orgInfo} />
			<Container>
				<Row>
					<Col>
                        <div className="mt-3">
                            <h3 className="fs-20rem text-left vt-txt-dark-blue">Product Colors</h3>
                            <BreadcrumbNav list={[{label: 'Home', url: '/'}, {label: `Colors - (${TotalListCount})`, url: false}]} />
                        </div>
                    </Col>
                    <Col>
                        <div className="text-right d-flex justify-content-end h-100 align-items-center">
                            <Button variant="primary" type="button" size="md" onClick={() => { setFormRowId(0); setShowFormModalBox(true); }} className="vt-primary-btn border-0 text-white fs-14rem">ADD COLOR</Button>
                        </div>
                    </Col>
                    <hr />
				</Row>
				<Row>
					<Col md="5" lg="4" className="mb-3">
						<div><label className="form-label fs-13rem fw-bold">Search by name</label></div>
						<div className="input-group">
							<input type="text" className="form-control" defaultValue={urlSearchQ} onKeyUp={handleChangeSearchQuery} placeholder="Color name" aria-label="Color name" />
							<div className="input-group-append">
								<Button variant="secondary" className="btn text-white btn-outline-secondary rounded-0" onClick={submitSearchQuery} type="button">Search</Button>
							</div>
						</div>
					</Col>
				</Row>
				<Row>
					<Col>
						<p className="text-muted fs-13rem">Colors are shared across all seller accounts. Set a hex swatch value for the storefront color picker.</p>
					</Col>
				</Row>
				<Row>
					<Col>
						<LoadTable />
					</Col>
				</Row>
			</Container>
			{(ShowFormModalBox) ? <FormModal loadapidata={loadApiData} setshowformmodalbox={(v) => { setShowFormModalBox(v); if (!v) setFormRowId(0); }} rowid={FormRowId || undefined} token={token} orginfo={orgInfo} /> : null}
		</>
	)
}

export default List;
